import React, { FC } from 'react'
import { useTheme } from '@shared/lib'

const ProgramsIcon: FC = () => {
  const theme = useTheme()

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5777_1071)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0043 3C10.4544 3 9.1019 3.06764 7.94903 3.16774C5.92469 3.3435 4.91251 3.43138 3.62315 4.72517C2.33378 6.01895 2.25288 6.98923 2.09109 8.92979C2.03697 9.57882 2.00391 10.2729 2.00391 11C2.00391 11.7272 2.03698 12.4213 2.0911 13.0704C2.2529 15.0109 2.3338 15.9811 3.62314 17.2749C4.91249 18.5687 5.92462 18.6565 7.94887 18.8323C9.10178 18.9324 10.4543 19.0001 12.0043 19.0001C13.5537 19.0001 14.9059 18.9325 16.0586 18.8324C18.0837 18.6566 19.0963 18.5687 20.3857 17.2747C21.6752 15.9807 21.756 15.01 21.9176 13.0685C21.9716 12.42 22.0046 11.7265 22.0046 11C22.0046 10.2736 21.9716 9.58019 21.9176 8.9317C21.756 6.99011 21.6752 6.01931 20.3857 4.7253C19.0963 3.43128 18.0836 3.3434 16.0584 3.16763C14.9057 3.06759 13.5536 3 12.0043 3ZM13.0002 8C13.0002 7.44772 12.5525 7 12.0002 7C11.448 7 11.0002 7.44772 11.0002 8V14C11.0002 14.5523 11.448 15 12.0002 15C12.5525 15 13.0002 14.5523 13.0002 14V8ZM8.00024 10C8.55253 10 9.00024 10.4477 9.00024 11V14C9.00024 14.5523 8.55253 15 8.00024 15C7.44796 15 7.00024 14.5523 7.00024 14V11C7.00024 10.4477 7.44796 10 8.00024 10ZM17.0002 10C17.0002 9.44772 16.5525 9 16.0002 9C15.448 9 15.0002 9.44772 15.0002 10V14C15.0002 14.5523 15.448 15 16.0002 15C16.5525 15 17.0002 14.5523 17.0002 14V10Z"
          fill={theme.colors.icon.tertiary}
        />
        <path
          d="M7.00413 21C7.00413 20.4477 7.45185 20 8.00413 20H16.0041C16.5564 20 17.0041 20.4477 17.0041 21C17.0041 21.5523 16.5564 22 16.0041 22H8.00413C7.45185 22 7.00413 21.5523 7.00413 21Z"
          fill={theme.colors.icon.tertiary}
        />
      </g>
      <defs>
        <clipPath id="clip0_5777_1071">
          <rect width="24" height="24" fill={theme.colors.icon.white} />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ProgramsIcon
